import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import { aiWordsUpgradeModalHided } from "src/slices/system";
import {
  AIwordsModalText,
  selectIsAIWordsUpgradeModalOpen,
} from "src/slices/system/selectors";

type Props = {};

const AIWordsUpgradeModal = (props: Props) => {
  const open = useSelector(selectIsAIWordsUpgradeModalOpen);
  const text = useSelector(AIwordsModalText);
  const dispatch = useDispatch();
  const handleOnClose = () => {
    dispatch(aiWordsUpgradeModalHided());
  };

  const handleOnCtaClick = () => {
    window.open("https://calendly.com/tomwinter/virtual-coffee", "_blank");
    dispatch(aiWordsUpgradeModalHided());
  };
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleOnClose}>
      <Box sx={{ p: 3 }}>
        <Typography align="center" variant="h5">
          {text}
        </Typography>
        <Typography align="center" variant="body2" gutterBottom>
          Do you want to upgrade your subscription to create more AI articles?
        </Typography>
        <Grid container sx={{ pt: 3 }}>
          <Grid xs={5}>
            <Image src="/app/images/popup-image.png" width={200} height={257} />
          </Grid>
          <Grid xs={7}>
            <Typography variant="body1" gutterBottom>
              Let's jump on a call and talk how you can:
            </Typography>
            <Typography variant="body2">
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Drive more organic traffic using AI articles
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Optimize the content for best performance
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Find more relevant topics to cover
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", pb: 0.5 }}>
                <CheckCircleOutlineIcon fontSize="inherit" sx={{ mr: 1 }} />
                Get more leads and boost your sales
              </Box>
            </Typography>
          </Grid>
        </Grid>

        <Button
          color="primary"
          variant="contained"
          fullWidth
          sx={{ mt: 4 }}
          onClick={handleOnCtaClick}
        >
          Let’s meet and talk
        </Button>
      </Box>
    </Dialog>
  );
};

export default AIWordsUpgradeModal;
